import { render, staticRenderFns } from "./UpdateUserPasswordModal.vue?vue&type=template&id=7a4f464b&"
import script from "./UpdateUserPasswordModal.vue?vue&type=script&lang=js&"
export * from "./UpdateUserPasswordModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports